var exports = {
  "wp": "sidebarContent__xBd6hp",
  "K3": "sidebarContentModernUx__EifTXL",
};

module.exports = exports;
